// extracted by mini-css-extract-plugin
module.exports = {"transitioning":"📚4-7-01416Q"};